module.exports = __webpack_public_path__ + "static/js-e8c27f6b0fcf596a06a31135d937c73e.png";